import localFont from 'next/font/local'

const TlichoFont = localFont({
	variable: '--font-tlicho',
	src: [
		{ path: './Tlicho-Regular 1 1.ttf', weight: '400' },
		{ path: './Tlicho-Italic 1 1.ttf', weight: '400', style: 'italic' },
		{ path: './Tlicho-Bold 1 1.ttf', weight: '700' }
	],
	display: 'swap',
	style: 'normal'
})

export default TlichoFont
